/* eslint react/prop-types:0 */
import React from 'react';

import { ADMIN_HOME_ID } from '@confluence/app-navigation/entry-points/navigationIDs';
import { BetaFeaturesSiteSettingsPageLoader } from '@confluence/beta-features/entry-points/BetaFeaturesSiteSettingsPage';
import { MainLayout } from '@confluence/main-layout';
import { Screen } from '@confluence/screen';

export const BetaFeaturesRoute = () => (
	<Screen screenEvent={{ name: 'betaFeaturesScreen' }}>
		<MainLayout navView={ADMIN_HOME_ID}>
			<BetaFeaturesSiteSettingsPageLoader />
		</MainLayout>
	</Screen>
);
